<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>
<div>
    <div class="background">
        <div [ngClass]="sideBar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' " class="hidden-xs sidebar">
            <div class="d-flex justify-content-between sticky p-3 border-bottom">
                <div class=" fs-24 strong pl-1">{{ 'home.contracts.Filterby' | cxTranslate }}</div>
                <div (click)="closeBar();clearFilterDataMobile($event)"><img src="/images/sidebarcross.svg" alt="Close Icon"> </div>
            </div>
            <div>
                <div class="d-flex strong  pl-4 pt-3 pb-2">{{ 'home.contracts.date' | cxTranslate }}:</div>
                <form role="form" [formGroup]="form" class="date-range-picker-form ml-4">
                            <div class="form-group pr-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                 
                                    <input name="datepicker" class="form-control form-control-lg multi-line-placeholder"  placeholder="Select contract date period"  ngbDatepicker #datepicker1="ngbDatepicker" [autoClose]="'outside'"
                                    (dateSelect)="onDateSelection($event,datepicker1)" 
                                    [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"[displayMonths]="2" [dayTemplate]="t"
                                    [footerTemplate]="footer" autocomplete="off" outsideDays="collapsed" [startDate]="startDate!" (click)="toggle(datepicker1)"  placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}">
                                <ng-template #t let-date let-focused="focused">
                                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                                        [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                                        (mouseleave)="hoveredDate = null" >
                                        {{ date.day }}
                                    </span>
                                </ng-template>
                                <ng-template #footer>
                                    <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker1)">{{ 'home.contracts.Reset' | cxTranslate }}</button>
                                    <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker1.close()">{{ 'home.quote.Close' | cxTranslate }}</button>
                                </ng-template>
                        </div>
                                </div>
                            </div>
                </form>
            </div>
            <div>
                <!-- <div class="d-flex strong  pl-4 pt-3 pb-2">{{ 'home.productHeader.Ports' | cxTranslate }} :
                </div>
                <div *ngFor="let portData of ports; let i=index" class=" ml-5  d-flex line-height ">
                    <label *ngIf="portData.name!==undefined && portData.name!==''">
            <input type="checkbox" [(ngModel)]="portData.selected" [value]="portData.name" [checked]="portData.selected"
              (change)="onCheckboxportChange($event,portData.id)" />
            {{portData.name}}
          </label>
                </div> -->
            </div>
            <div>
                <div class="d-flex strong  pl-4 pt-3 pb-2">{{ 'home.contracts.products' | cxTranslate }} :</div>
                <div *ngFor="let productData of productlist; let i=index" class="ml-5  d-flex line-height ">
                    <label *ngIf="productData!==undefined && productData!==''">                                                    
            <input type="checkbox" [(ngModel)]="productData.selected" [value]="productData.name"
              [checked]="productData.selected" (change)="onCheckboxproductChange($event , productData.name)" />
            {{productData.name}}
          </label>
                </div>
            </div>
            <div class="stickybottom p-4 border-top">
                <button class="btn btn-block btn-primary" (click)="getContractsResults()">{{ 'home.contracts.seeResults' |
          cxTranslate }}</button>
                <button class='btn btn-block' (click)="clearFilterDataMobile($event);clear()">{{ 'home.contracts.clearFilter' |
          cxTranslate }}</button>
            </div>
        </div>
    </div>
    <div>
         <div *ngIf="displayLoading" class="mt-5" id="loader"></div>
        <div class="filter" *ngIf="!displayLoading">
            <div class="container pb-sm-0">
                <div class="d-flex justify-content-between">
                    <div class="d-flex w-65">
                        <div class="filter-mobile  strong mt-4 text-nowrap">{{ 'home.contracts.Filterby' | cxTranslate }}</div>
                           <div class="col-md-4">
                                <input name="datepicker" placeholder="Select contract date period" class="form-control filter-bar-input mobile ml-2 mt-3 pt-0 multi-line-placeholder" ngbDatepicker #datepicker="ngbDatepicker" [autoClose]="'outside'"
                                    (dateSelect)="onDateSelection($event,datepicker)"
                                    [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''" [displayMonths]="2" [dayTemplate]="t"
                                    [footerTemplate]="footerTemplate" autocomplete="off" outsideDays="hidden" [startDate]="startDate!" (click)="toggle(datepicker)">
                                <ng-template #t let-date let-focused="focused">
                                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                                        [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                                        (mouseleave)="hoveredDate = null">
                                        {{ date.day }}
                                    </span>
                                </ng-template>
                                <ng-template #footerTemplate>
                                    <hr class="my-0">
                                    <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker)">{{ 'home.contracts.Reset' | cxTranslate }}</button>
                                    <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker.close()">{{ 'home.quote.Close' | cxTranslate }}</button>
                                </ng-template>
                        </div>
                        <div class="col-md-3 mr-2 mt-3 d-none d-lg-block">
                            <ng-select [items]="productsList" [multiple]="true" [clearable]="false" bindLabel="productsList"
                                dropdownPosition="bottom" groupBy="productsList" [selectableGroup]="true" placeholder="Select products"
                                [(ngModel)]="selectedMaterial" [closeOnSelect]="true" bindValue="productsList"
                                notFoundText="{{'heading.NoItemsFound' | cxTranslate }}" (change)="filterData()">
                                <ng-template ng-multi-label-tmp>
                                    <span class="filter-count pl-2 text-black">{{selectedMaterial?.length}}x selected</span>
                                </ng-template>
                                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" class="dropdown-ng-template">
                                    <!-- <input type="checkbox" /> -->
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    <div>
                                        <input id="{{item}}" [ngModel]="item$.selected" [checked]="item.checked" type="checkbox" />
                                        <span>{{item}}</span>
                                    </div>
                                </ng-template>
                            </ng-select>                           
                         </div>
                        <div>
                            <button (click)="clearFilterData(); onReset($event)" class="btn mt-3 btn-warning  text-white ml-2 " [style.visibility]="selectedStatus != null || startDate != null || selectedMaterial != null || selectedMaterial?.length>0|| clearBtn ? 'visible' : 'hidden'">
          {{ 'home.contracts.clearFilter' |
          cxTranslate }}
        </button>
                        </div>
                    </div>
                    <div class="d-inline-flex contractsearch ml-lg-5 my-3 filter-select-div">
                        <div class="input-group">
                            <input class="form-control form-control-lg border rounded-pill " [(ngModel)]="searchValue" type="search" (input)="searchContracts()" placeholder="{{ 'home.contracts.Search' | cxTranslate }}" id="example-search-input" (keypress)="omitSpecialChar($event)" 
                            />
                            <span class="input-group-append">
              <button name='searchbuttonfilternew'
                class="btn rounded-pill border-0 border-start-0 bg-white border-bottom-0 border ms-n5 "
                >
                <i class="fa fa-search pe-none"></i>
              </button>
              <div class='hidden-xs vertical'></div>
              <div class='hidden-xs filterpad' (click)='filterSideBar()'>
                <img class="mt-n1 mr-1 ml-1" src="/images/filternew.svg"><sup
                  *ngIf='length'>{{length}}</sup>
                <div class="filternew">Filter</div>
              </div>
            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
          <div class="container" *ngIf="!displayLoading">
                <section id="tabs" class="project-tab ipad-pro">
                    <div class="row d-flex justify-content-between px-2" >
                    <div class="col-lg-2 tabDiv">
                    <nav class="product-tab ">
                        <div class="nav nav-fill nav-tabs pe-auto" id="nav-tab" role="tablist">
                            <div class="nav-item nav-link  tab-bar strong" [class.active]="activeTab === 'Active'"
                                id="nav-home-tab" data-toggle="tab" role="tab" aria-controls="nav-home"
                                aria-selected="false" (click)="changeTab('Active')">Active
                            </div>
                            <div class="nav-item nav-link  tab-bar strong" [class.active]="activeTab === 'Completed'"
                                id="nav-home-tab" data-toggle="tab" role="tab" aria-controls="nav-home"
                                aria-selected="false" (click)="changeTab('Completed')">Completed
                            </div>
                        </div>
                    </nav>
                </div>
                    <!-- <div>
                        <span class="grid-icon ml-3">Display as:
                        <img class="grid-icon" title="grid" [src]='gridSrc' (click)="viewGrid()" >
                        <img class="list-icon" title="list" [src]='listSrc' (click)=" viewList()">
                    </span>
                    </div> -->
                    </div>
                </section>
                <div class="border-bottom"></div>
            </div>
        <div class="container mt-5" *ngIf="(activeTab==='Active' || activeTab === 'Completed')">
           
            <div *ngIf="noData && !displayLoading" class="text-center strong  text-primary mb-5">
                {{'home.contracts.Noresults' | cxTranslate }}</div>
            <div *ngIf="!displayLoading">
                <div class="card pt-3 pb-3 pl-4 pr-4 mb-4 border-radius-05" *ngFor='let a of contractsData'>
                    <div class="d-inline-flex justify-content-between">
                        <div class="d-inline-flex justify-content-between">
                            <div class=" text-secondary">{{ 'home.quote.Id' | cxTranslate }} {{a.zfiscalYearOfferSDK}} / {{a.zctContractNumberExternalKeySDK}}
                            </div>
                        </div>
                        <div>
                            <span class=" text-secondary">
                Contract start date: {{convertDate(a.zcontractStartDateSDK)}}
              </span>
                        </div>
                    </div>
                    <div class="hr">
                    </div>
                    <div *ngFor="let detail of a.ctContractEntries ; let index=index" class="inside-layout">
                        <div class="pb-2">
                            <div class="h5 mb-0 fw-bold">{{detail.productName | titlecase }}</div>
                            <!-- <div class="h5 mb-0 text-secondary"> {{detail.portName}}</div> -->
                        </div>
                        <div class=" d-flex pb-4">
                            <div class="mt-50">
                                <div class="small text-secondary">Schedule</div>
                                <div class="strong"> {{detail.laycanStartDate }} - {{detail.laycanEndDate}}</div>
                            </div>
                            <div class="ml-5">
                                <div class="small text-secondary">{{'home.quote.Quantity' | cxTranslate}} ({{detail.quantityUOMDesc}})</div>
                                <div class="strong"> {{ detail.quantity | number}} </div>
                            </div>
                            <br>
                        </div>
                    </div>
                    <!-- <div class="inside-layout-last d-none">
                        <div class="mt-2 text-primary value-adjust"> <i class="fas fa-file-alt"></i>
                            <a class="strong text-primary">
                {{ "home.contracts.coa" | cxTranslate }}</a>
                        </div>
                        <div class="view-details mt-2 text-primary value-adjust"> <i class="fas fa-file-alt"></i>
                            <a class="strong text-primary">
                {{ "home.contracts.paymentInvoice" | cxTranslate }}</a>
                        </div>
                        <div class="view-details mt-2 text-primary value-adjust"> <i class="fas fa-file-alt"></i>
                            <a class="strong text-primary">
                {{ "home.contracts.releaseOrder" | cxTranslate }}</a>
                        </div>
                        <div class="view-details mt-2 text-primary value-adjust"> <i class="fas fa-file-alt"></i>
                            <a class="strong text-primary">
                {{ "home.contracts.VATinvoice" | cxTranslate }}</a>
                        </div>
                    </div> -->
                </div>
            </div>
            <div *ngIf="loaderShow" id="loader"></div>
            <div class="text-center strong  text-primary mb-5" *ngIf="reachedToEnd"> {{ "home.contracts.Nomore" | cxTranslate }}</div>
        </div>
    </div>
</div>